import {useCallback} from "react";
import type {Backend} from "../api";
import {AsyncState} from "../components/AsyncState";
import {useScreenData} from "./useScreenData";
import {DeadlinePanel} from "./DeadlinePanel";
export function CustomerDeadlineSection({backend,customerId,onUnauthorized}:{backend:Backend;customerId:string;onUnauthorized:()=>void}){
 const load=useCallback(()=>backend.deadlines!({customerId,timezone:Intl.DateTimeFormat().resolvedOptions().timeZone}),[backend,customerId]);
 const data=useScreenData(load,()=>false,onUnauthorized);
 return <section className="screen"><p className="muted">Сроки договоров, лицензий и обслуживания оборудования этого клиента.</p><AsyncState phase={data.phase} onRetry={data.reload}>{data.value&&<DeadlinePanel items={data.value.items}/>}</AsyncState></section>;
}
